<template>
  <div class="card-item-wrapper p-d-12">
    <div class="card-item">
      <div @click="detail">
        <div class="top-card" v-if="customer.is_loyalty === 1">
          <div class="chip-whitelabel">
            <div class="f-semi f-12 f-c-information-blue-normal">
              Loyalty Apps
            </div>
          </div>
        </div>
        <div class="top-card">
          <div class="f-semi f-16 f-c-black" v-if="!isSearch">{{ customerName }}</div>
          <div class="f-semi f-16 f-c-black" v-else v-html="searchHighlight(customerName, keySearch)"></div>
          <div class="card-chevron"></div>
        </div>
        <span class="f-12 f-semi p-1 p-x-4 rounded text-primary" style="background: #EDF5FF;" v-if="showMember">
					{{ customer.member_name }}
				</span>
        <div class="f-regular f-13 f-c-midgrey m-t-4">
          <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.6665 1.66683C2.48969 1.66683 2.32012 1.73707 2.1951 1.86209C2.07008 1.98712 1.99984 2.15669 1.99984 2.3335V11.6668C1.99984 11.8436 2.07007 12.0132 2.1951 12.1382C2.32012 12.2633 2.48969 12.3335 2.6665 12.3335H9.33317C9.50998 12.3335 9.67955 12.2633 9.80458 12.1382C9.9296 12.0132 9.99984 11.8436 9.99984 11.6668L9.99984 5.00016H7.99984C7.64621 5.00016 7.30708 4.85969 7.05703 4.60964C6.80698 4.35959 6.6665 4.02045 6.6665 3.66683V1.66683H2.6665ZM7.99984 2.60964V3.66683H9.05703L7.99984 2.60964ZM1.25229 0.919282C1.62736 0.54421 2.13607 0.333496 2.6665 0.333496H7.33317C7.50998 0.333496 7.67955 0.403734 7.80457 0.528758L11.1379 3.86209C11.2629 3.98712 11.3332 4.15668 11.3332 4.3335L11.3332 11.6668C11.3332 12.1973 11.1225 12.706 10.7474 13.081C10.3723 13.4561 9.86361 13.6668 9.33317 13.6668H2.6665C2.13607 13.6668 1.62736 13.4561 1.25229 13.081C0.877218 12.706 0.666504 12.1973 0.666504 11.6668V2.3335C0.666504 1.80306 0.877217 1.29436 1.25229 0.919282Z"
                fill="#C8D0DD"/>
          </svg>
          <span class="p-l-8">
						Total {{ customer.total_transaksi }} Transaksi
					</span>
        </div>
        <div class="f-regular f-13 f-c-midgrey m-t-4">
          <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M4.33348 0.666504C4.70167 0.666504 5.00014 0.964981 5.00014 1.33317V1.99991H9.00018V1.33317C9.00018 0.964981 9.29866 0.666504 9.66685 0.666504C10.035 0.666504 10.3335 0.964981 10.3335 1.33317V1.99991H11.6668C12.7714 1.99991 13.6668 2.89534 13.6668 3.99991V13.3332C13.6668 14.4378 12.7714 15.3332 11.6668 15.3332H2.3335C1.22893 15.3332 0.333496 14.4378 0.333496 13.3332V3.99991C0.333496 2.89534 1.22893 1.99991 2.3335 1.99991H3.66681V1.33317C3.66681 0.964981 3.96529 0.666504 4.33348 0.666504ZM3.66681 3.33324H2.3335C1.96531 3.33324 1.66683 3.63172 1.66683 3.99991V5.99991H12.3335V3.99991C12.3335 3.63172 12.035 3.33324 11.6668 3.33324H10.3335V3.99984C10.3335 4.36803 10.035 4.6665 9.66685 4.6665C9.29866 4.6665 9.00018 4.36803 9.00018 3.99984V3.33324H5.00014V3.99984C5.00014 4.36803 4.70167 4.6665 4.33348 4.6665C3.96529 4.6665 3.66681 4.36803 3.66681 3.99984V3.33324ZM12.3335 7.33324H1.66683V13.3332C1.66683 13.7014 1.96531 13.9999 2.3335 13.9999H11.6668C12.035 13.9999 12.3335 13.7014 12.3335 13.3332V7.33324Z"
                  fill="#C8D0DD"/>
          </svg>
          <span class="p-l-8">
						{{ customer.transaksi_terakhir }}
					</span>
        </div>
        <div class="f-regular f-13 f-c-midgrey m-t-4" v-if="filterSaldoEpayment">
          Saldo E-payment {{ formatRupiah(customer.saldo_epayment) }}
        </div>
      </div>
      <div class="separator-line m-x-min m-t-10" v-if="customer.phone !== ''"></div>
      <div class="bottom-card m-t-8 d-flex-between-center" style="position: relative"
           v-if="customer.phone !== ''"
      >
        <div class="f-regular f-14 f-c-midgrey" v-if="!isSearch">
          {{ customer.country_code }}{{ customer.phone }}
        </div>
        <div class="f-regular f-14 f-c-black" v-else v-html="searchHighlight(customer.country_code + customer.phone, keySearch)"></div>
        <div class="clik"
             :id="'dropdownMenuLink'+customer"
             data-toggle="dropdown"
             aria-haspopup="true"
             aria-expanded="false">
        </div>
        <button type="button" class="btn btn-outline-primary f-12" style="padding: 2px 8px;">
          Hubungi
          <img src="../../../assets/icons/chevron-rotate-down.svg" alt=""
               class="m-l-4" style="height: 14px">
        </button>
        <div class="dropdown-menu garis-listkomisi">
          <a class="dropdown-item icon-2" @click="handleCommunicate('tel')">
					<span class="mar-right-10">
						<img src="../../../assets/icons/phone-call.svg">
					</span>
            Telepon
          </a>
          <a class="dropdown-item icon-2" @click="handleCommunicate('sms')">
					<span class="mar-right-10">
						<img src="../../../assets/icons/email.svg">
					</span>
            SMS
          </a>
          <a class="dropdown-item icon-2" @click="handleWa()">
					<span class="mar-right-10">
						<img src="../../../assets/icons/mdi_whatsapp.svg">
					</span>
            Whatsapp
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import File2020 from "@/so-components/global/icons/iconPacks/File2020.vue";
import SOIconBase from "@/so-components/global/icons/SOIconBase.vue";

export default {
  name: "SOCardCustomer",
  components: {
    File2020,
    SOIconBase,
  },
  props: [
    "customer",
    "keySearch",
    "isSearch",
    "filterSaldoEpayment",
  ],
  methods: {
    detail(event) {
      this.$emit("detail", event)
    },
    handleWa() {
      const flutterConfig = JSON.parse(localStorage.getItem('flutterConfig'))
      const phone = this.customer.telp
      if (this.isWebview() && flutterConfig.platform !== 'web') {
        this.flutterSendWa(phone)

      } else {
        window.open(`https://wa.me?phone=${phone}`, '_blank');
      }
    },
		handleCommunicate(context) {
			const flutterConfig = JSON.parse(localStorage.getItem('flutterConfig'))
      const phone = this.customer.telp
      if (this.isWebview() && flutterConfig.platform !== 'web') {
        this.flutterHandleCommunicate(context, phone)
      } else {
        window.open(`${context}:${phone}`, '_blank');
      }
		}
  },
  computed: {
    customerName() {
      const name = this.customer.nama;
      const greet = this.customer.sapaan ? this.customer.sapaan + ' ' :  '';
      return greet + name;
    },
    showMember() {
      return !this.customer.member_active_expired && this.customer.member_name !== ""
    }
  }
}
</script>

<style scoped>
.dropdown-menu.garis-listkomisi.show {
  top: -132px !important;
}

.chip-whitelabel {
  background-color: #EDF5FF;
  color: #206CFE;
  padding: 4px;
  border-radius: 3px;
}

.chip-whitelabel {
  background-color: #EDF5FF;
  padding: 4px;
  gap: 4px;
  border-radius: 3px;
  margin-bottom: 4px;
}
</style>